import { render, staticRenderFns } from "./voucher-sale.vue?vue&type=template&id=fcbb1588&scoped=true&"
import script from "./voucher-sale.vue?vue&type=script&lang=ts&"
export * from "./voucher-sale.vue?vue&type=script&lang=ts&"
import style0 from "./voucher-sale.vue?vue&type=style&index=0&id=fcbb1588&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbb1588",
  null
  
)

export default component.exports